import FolderIcon from '@mui/icons-material/Folder';
import { LoadingButton } from "@mui/lab";
import { Avatar, Box, Button, List, ListItem, ListItemText, Modal, Typography, useMediaQuery } from "@mui/material";
import ListItemAvatar from '@mui/material/ListItemAvatar';
import MyToastShow from '@/components/Layout/MyToast';
import dayjs from 'dayjs';
import { useState } from "react";
import { usePagarCarritosMutation } from "../../redux/api/informeApi";
import { ICarrito } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";

type ModalLiquidarInformesProps = {
    open: boolean;
    onCancel: () => void;
    carpetas: ICarrito[];
    onCarpetasPagadas: (carpetas: ICarrito[]) => void;
};
const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    boxShadow: 24,
    p: 4,
};

export type PagaInformesArgs = {
    idCarritos: number[];
};

const ModalPagarCarpetas = ({
    carpetas,
    open,
    onCancel,
    onCarpetasPagadas,
}: ModalLiquidarInformesProps) => {
    const darkMode = useAppSelector((state: any) => state.theme.darkTheme);

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
    const boxWidth = isMobile ? "100%" : "40rem";


    const [pagarCarritos] = usePagarCarritosMutation();
    const [loading, setLoading] = useState(false);


    const handlePagar = () => {
        setLoading(true)
        pagarCarritos(carpetas.map((c) => c.idCarrito))
            .unwrap()
            .then((data) => {
                MyToastShow({
                    message: "Las carpetas se pagaron correctamente",
                    type: "success",
                });

                onCarpetasPagadas(carpetas);
            })
            .finally(() => {
                setLoading(false)
                onCancel()
            })


    }


    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`pagar-informes`}
            sx={{
                width: "100%",
            }}
        >
            <Box
                sx={(theme) => ({
                    ...style,
                    width: boxWidth,
                    overflow: "auto",
                    maxHeight: "100%",
                    bgcolor: darkMode ? "#232323" : "#fff",
                })}
                aria-label={`pagar-container-informes`}
            >
                {carpetas.length > 0 ? (
                    <>
                        <Typography variant="h5" sx={{ mb: 2 }}>
                            ¿Está seguro que desea pagar las carpetas seleccionadas?
                        </Typography>

                        {
                            carpetas.map((carpeta) => (
                                <List key={`carrito-list-map-${carpeta.idCarrito}`}>
                                    <ListItem
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <FolderIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            //@ts-ignore
                                            primary={dayjs(carpeta.fecha).format("DD/MM/YYYY")}
                                            secondary={carpeta.idCarrito}
                                        />
                                    </ListItem>
                                </List>
                            ))
                        }
                    </>

                ) : <>No hay carpetas para pagar</>}



                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        color="error"
                        onClick={() => handlePagar()}
                    >

                        Pagar
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ ml: 1 }}
                        onClick={() => onCancel()}
                    >

                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal >
    );
};

export default ModalPagarCarpetas;
